const targetTypes = {
  CLASS: 'class',
  ATTRIBUTE: 'attribute',
};

export default targetTypes;
